import { forwardRef, type ComponentPropsWithoutRef } from "react";

import { cn } from "@/shared/lib/utils";

import { Input } from "../primitives/input";

type ColocaInputProps = Omit<ComponentPropsWithoutRef<"input">, "value" | "onChange"> & {
  value: string;
  onValueChange: (value: string) => void;
};

// Standalone (not RHF-bound) — use `ColocaInputField` for form-bound text.
export const ColocaInput = forwardRef<HTMLInputElement, ColocaInputProps>(function ColocaInput(
  { value, onValueChange, className, ...rest },
  ref,
) {
  return (
    <Input
      ref={ref}
      value={value}
      onChange={(event) => onValueChange(event.target.value)}
      className={cn(className)}
      {...rest}
    />
  );
});
